module.exports = fox._r("images/press/icon-read-blog.png", __webpack_public_path__ + "_/common/images/press/icon-read-blog.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-read-blog.png
// module id = 382
// module chunks = 2